export const researchParametersData = [
    {
        key: 'vfl',
        name: '內臟脂肪級別',
        unit: '',
        minValue: 0,
        maxValue: 99,
        normalRange: [1, 9],
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: 'vflLower',
        normalMaxValueKey: 'vflUpper',
        deltaValueKey: 'deltaVFL',
    },
    {
        key: 'whr',
        name: '腰臀圍比',
        unit: '',
        minValue: 0,
        maxValue: 1,
        normalRange: [0.75, 0.85],
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: 'whrLower',
        normalMaxValueKey: 'whrUpper',
        deltaValueKey: 'deltaWHR',
    },
    {
        key: 'skeletalMuscleIndex',
        name: '肌肉質量指數',
        unit: 'kg/m2',
        normalRange: [],
        minValue: 0,
        maxValue: 99,
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: '',
        normalMaxValueKey: '',
        deltaValueKey: 'deltaSMI',
    },
    {
        key: 'bmc',
        name: '骨礦含量',
        unit: 'L',
        normalRange: [],
        minValue: 0,
        maxValue: 99,
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: '',
        normalMaxValueKey: '',
        deltaValueKey: 'deltaBMC',
    },
    {
        key: 'bmr',
        name: '基礎代謝率',
        unit: 'kcal',
        normalRange: [],
        minValue: 0,
        maxValue: 99,
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: '',
        normalMaxValueKey: '',
        deltaValueKey: 'deltaBMR',
    },
    {
        key: 'recommendedCaloricIntake',
        name: '建議攝取熱量',
        unit: 'Kcal',
        normalRange: [],
        minValue: 0,
        maxValue: 99,
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: '',
        normalMaxValueKey: '',  
        deltaValueKey: 'deltaRecommendedCaloricIntake',
    },
];

const researchParametersBarData = [
    {
        key: 'vfl',
        name: '內臟脂肪級別',
        unit: '',
        minValue: 0,
        maxValue: 99,
        normalRange: [1, 9],
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: 'vflLower',
        normalMaxValueKey: 'vflUpper',
        deltaValueKey: 'deltaVFL',
    },
    {
        key: 'whr',
        name: '腰臀圍比',
        unit: '',
        minValue: 0,
        maxValue: 1,
        normalRange: [0.75, 0.85],
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: 'whrLower',
        normalMaxValueKey: 'whrUpper',
        deltaValueKey: 'deltaWHR',
    },
];

const researchParametersCardData = [
	{
		key: "skeletalMuscleIndex",
		name: "肌肉質量指數",
		unit: "kg/m2",
		normalRange: [],
		minValue: 0,
		maxValue: 99,
		minValueKey: "",
		maxValueKey: "",
		normalMinValueKey: "",
		normalMaxValueKey: "",
		deltaValueKey: "deltaSkeletalMuscleIndex",
	},
	{
		key: "bmc",
		name: "骨礦含量",
		unit: "L",
		normalRange: [],
		minValue: 0,
		maxValue: 99,
		minValueKey: "",
		maxValueKey: "",
		normalMinValueKey: "",
		normalMaxValueKey: "",
		deltaValueKey: "deltaBMC",
	},
	{
		key: "bmr",
		name: "基礎代謝率",
		unit: "kcal",
		normalRange: [],
		minValue: 0,
		maxValue: 99,
		minValueKey: "",
		maxValueKey: "",
		normalMinValueKey: "",
		normalMaxValueKey: "",
		deltaValueKey: "deltaBMR",
	},
	{
		key: "recommendedCaloricIntake",
		name: "建議攝取熱量",
		unit: "Kcal",
		normalRange: [],
		minValue: 0,
		maxValue: 99,
		minValueKey: "",
		maxValueKey: "",
		normalMinValueKey: "",
		normalMaxValueKey: "",
		deltaValueKey: "deltaRecommendedCaloricIntake",
	},
];

export default { researchParametersData, researchParametersBarData, researchParametersCardData };
